export const X_CHROMOSOME_ID = 23;
export const Y_CHROMOSOME_ID = 24;
export var EChromosomes;
(function (EChromosomes) {
    EChromosomes["X"] = "X";
    EChromosomes["Y"] = "Y";
    EChromosomes["XX"] = "XX";
    EChromosomes["XY"] = "XY";
})(EChromosomes || (EChromosomes = {}));
